import {
  GetCollaboratorCmSheetSoftSkillsResponse,
  UpdateCollaboratorCmSheetSoftSkillsRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetSoftSkillsService = {
  async get(
    cmSheetId: number,
  ): Promise<GetCollaboratorCmSheetSoftSkillsResponse> {
    const response =
      await httpClient.get<GetCollaboratorCmSheetSoftSkillsResponse>(
        `v1/cm-sheets/${cmSheetId}/soft-skills`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorCmSheetSoftSkillsRequest,
  ): Promise<void> {
    await httpClient.put(`v1/cm-sheets/${cmSheetId}/soft-skills`, body);
  },
};

export default CmSheetSoftSkillsService;
